import { render, staticRenderFns } from "./tears.vue?vue&type=template&id=2233c797&scoped=true&"
import script from "./tears.vue?vue&type=script&lang=js&"
export * from "./tears.vue?vue&type=script&lang=js&"
import style0 from "./tears.vue?vue&type=style&index=0&id=2233c797&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2233c797",
  null
  
)

export default component.exports